import React, { useRef, useState } from "react";
import { LSSB } from "../utils/LSSB_live";
import { useQuery } from "@tanstack/react-query";
import { ClipLoader } from "react-spinners";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { TransmitSquare } from "iconsax-react";
import Lottie from "react-lottie";
import animationData from "../assets/empty.json";

const Invoice = () => {
  const contentRef = useRef();

  const [isLoading, setIsLoading] = useState(false);
  let userData = sessionStorage.getItem("lssbAdminData");
  userData = JSON.parse(userData);

  const fetchProfile = async (page) => {
    let res = await LSSB.make_API_call({
      $k: userData.token,
      _endpoint: "fetch_users",
      $where: { _id: "$self" },
    });

    return res;
  };

  const profileQuery = useQuery(["profile"], () => fetchProfile());

  let invoice = profileQuery?.data?.data?.data?.invoices || [];

  const resultArray = Object.keys(invoice).map((key) => ({
    key, // Preserve the original key (like 'lagos_state_bursary', 'random_test')
    ...invoice[key], // Spread the inner object properties
  }));

  console.log("grants rsss=====>>>", resultArray);

  const handleDownload = (id) => {
    const input = document.getElementById(id);

    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgWidth = 210; // Adjust width according to your requirement
      const pageHeight = pdf.internal.pageSize.height;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("Invoice.pdf");
    });
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  return (
    <div className="px-4 py-6 md:px-7 md:py-10">
       {(!invoice || resultArray.length === 0) && (<div className="h-[80vh] w-full flex justify-center items-center">
          <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg max-w-[420px] w-full md:max-w-[520px] 2xl:max-w-[580px] mx-auto">
            <Lottie options={defaultOptions} height={200} width={200} />
            <p className="text-base md:text-lg  font-medium text-[#515B6F] text-center mt-5 ">
              No Invoice Issued{" "}
            </p>
            <p className="text-base md:text-lg  font-medium text-[#515B6F] mt-4  text-center">
              Apply for paid awards to see invoices here!
            </p>
            <Link
              to="/grants"
              className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] flex items-center justify-center gap-2 "
            >
              <p className=" text-md md:text-lg text-white ">Apply</p>
            </Link>
          </div>

        </div>
         
        )}
      <div className="grid grid-cols-1 lg:grid-cols-2  gap-10">
       

        {invoice &&
          resultArray?.map((invoice) => (
            <div
              ref={contentRef}
              className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg max-w-[420px] w-full md:max-w-[520px] 2xl:max-w-[580px] mx-auto"
            >
              <div className="w-full flex justify-right mb-3">
                <button
                  onClick={() => handleDownload(invoice?.invoice_num)}
                  className="text-red px-2 py-1 rounded-md border  hover:bg-gray-300 self-end"
                >
                  <TransmitSquare size="18" color="#AF8544" />
                </button>
              </div>

              <ul id={invoice?.invoice_num}>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center">
                  {" "}
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    Invoice
                  </p>
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    #{invoice?.invoice_num}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-2">
                  {" "}
                  <p className="text-md md:text-base  font-medium text-[#515B6F] ">
                    Date:
                  </p>
                  <p className="text-md md:text-base  font-normal text-[#515B6F] ">
                    {invoice?.invoice_date}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-2">
                  {" "}
                  <p className="text-md md:text-base  font-medium text-[#515B6F] ">
                    Billed TO:
                  </p>
                  <p className="text-md md:text-base  font-normal text-[#515B6F] ">
                    {userData?.user?._fields?.fullname}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-2">
                  {" "}
                  <p className="text-md md:text-base  font-medium text-[#515B6F] ">
                    Payment For:
                  </p>
                  <p className="text-md md:text-base  font-normal text-[#515B6F] ">
                    {invoice?.grant_name}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-2">
                  {" "}
                  <p className="text-md md:text-base  font-medium text-[#515B6F] ">
                    Education Level:
                  </p>
                  <p className="text-md md:text-base  font-normal text-[#515B6F] ">
                    {invoice?.edu_level}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-3">
                  {" "}
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    Total Due
                  </p>
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    # {invoice?.pay_amount}
                  </p>
                </li>
                <li className="pb-2 md:pb-3 border-dashed border-b border-[#D6DDEB] flex justify-between items-center mt-3">
                  {" "}
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    Status
                  </p>
                  <p className="text-base md:text-lg  font-medium text-[#515B6F] ">
                    {invoice?.pay_status}
                  </p>
                </li>
              </ul>

              <div className="flex items-center  gap-[20px]">
                <Link
                  to={invoice?.pay_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-full mb-4 mt-8  py-[8px] md:py-[10px]  text-center  ${
                    invoice?.pay_status === "pending"
                      ? "bg-[#FFF5E6] text-[#F44336] border-[#FF9800]"
                      : "bg-[#EDF7EE] text-[#4CAF50] border-[#4CAF50]"
                  }`}
                >
                  <p className=" text-md md:text-lg  ">
                    {invoice?.pay_status === "pending" ? "Pay Now" : "Paid"}
                  </p>
                </Link>

                <button
                  // onClick={() => {
                  //   UpdateUser();
                  // }}
                  className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] flex items-center justify-center gap-2 "
                >
                  <p className="text-white text-md md:text-lg  ">
                    Verify Payment
                  </p>{" "}
                  {isLoading && <ClipLoader color={"white"} size={20} />}
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Invoice;
